<template>
    <page-layout :body-style="{ paddingTop: 0 }">
        <template #header>
            <g-button icon="angle-left" theme="live" size="small" @click="handleGoBack">Back</g-button>
        </template>
        <g-loader v-if="isLoading" type="fixed" />
        <template v-else>
            <div v-if="productsList.length > 0">
                <g-row :gutter="16">
                    <g-column v-for="product in productsList" :key="product.id" :span="12">
                        <product-list-item
                            :product="product"
                            :show-price="showPrice"
                            :currency="currency"
                            class="margin-bottom"
                            @click="handleProductClick"
                        />
                    </g-column>
                </g-row>
                <div v-if="hasPagination">
                    <g-level>
                        <template #center>
                            <g-level-item>
                                <g-button
                                    icon="chevron-left"
                                    theme="live"
                                    size="large"
                                    :disabled="isPreviousButtonDisabled"
                                    @click="$emit('prev-page')"
                                />
                            </g-level-item>
                            <g-level-item>
                                <g-button
                                    icon="chevron-right"
                                    theme="live"
                                    size="large"
                                    :disabled="isNextButtonDisabled"
                                    @click="$emit('next-page')"
                                />
                            </g-level-item>
                        </template>
                    </g-level>
                </div>
            </div>
            <template v-else-if="collections.length > 0">
                <div v-for="collection in collections" :key="collection.id" class="margin-bottom">
                    <collection-list-item :collection="collection" @click="handleCollectionClick" />
                </div>
            </template>
            <template v-else>
                <out-of-stock :custom-message="customOutOfStockMessage" />
            </template>
        </template>
    </page-layout>
</template>

<script>
    import get from 'lodash/get';
    import PageLayout from '../../layouts/PageLayout.vue';
    import CollectionListItem from './partials/CollectionListItem.vue';
    import ProductListItem from './partials/ProductListItem.vue';
    import OutOfStock from '../../library/OutOfStock.vue';

    export default {
        name: 'ProductsListView',
        components: {
            PageLayout,
            CollectionListItem,
            ProductListItem,
            OutOfStock
        },
        props: {
            currentPage: {
                type: Number,
                default: 1
            },
            perPage: {
                type: Number,
                required: true
            },
            products: {
                type: Object,
                default: undefined
            },
            campaign: {
                type: Object,
                default: undefined
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            collections() {
                return get(this.products, 'categories', []);
            },
            productsList() {
                return get(this.products, 'products.data', []);
            },
            showPrice() {
                return get(this.campaign, 'compensation_settings.show_prices', true);
            },
            currency() {
                return get(this.campaign, 'brand.currency', '');
            },
            restriction() {
                return this.$route.query.restriction;
            },
            productIndex() {
                return this.$route.query.productIndex;
            },
            isPreviousButtonDisabled() {
                return this.currentPage < 2;
            },
            totalProducts() {
                return get(this.products, 'products.meta.total', 1);
            },
            isNextButtonDisabled() {
                const productsPaged = this.currentPage * this.perPage;
                return productsPaged >= this.totalProducts;
            },
            hasPagination() {
                return !this.isNextButtonDisabled || !this.isPreviousButtonDisabled;
            },
            customOutOfStockMessage() {
                return get(this.campaign, 'customization.products_out_of_stock_message', null);
            }
        },
        methods: {
            handleCollectionClick(id) {
                this.$router.push({
                    name: 'v2.productSelection.products',
                    query: {
                        restriction: this.restriction,
                        productIndex: this.productIndex,
                        collection_id: id
                    }
                });
            },
            handleProductClick(product) {
                const query = {
                    productIndex: this.productIndex,
                    variantId: product.variant_id
                };

                if (product.variant_id) {
                    query.readonly = true;
                }

                this.$router.push({
                    name: 'v2.productSelection.product',
                    params: {
                        product_id: product.id
                    },
                    query
                });
            },
            handleGoBack() {
                this.$router.go(-1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom {
        margin-bottom: $g-spacing-5;
    }
</style>
